var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaseStudy3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-analysis-U9GA3CY584 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.70428 8.20191H44.2958C44.7654 8.20191 45.1916 8.39349 45.5 8.70191C45.8097 9.01237 46.0001 9.43987 46.0001 9.90622V33.017C46.0001 33.4864 45.8085 33.9128 45.5 34.2213C45.1915 34.5298 44.7652 34.7213 44.2958 34.7213H5.70428C5.23793 34.7213 4.81214 34.5292 4.50169 34.2196C4.19326 33.9111 3.99997 33.4866 3.99997 33.017V9.90622C3.99997 9.43661 4.19148 9.01033 4.49994 8.70188C4.8084 8.39342 5.23467 8.20191 5.70428 8.20191ZM44.25 9.95196H5.74997V32.9713H44.25V9.95196Z",
    fill: "#EE4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.9554 32.9712H29.0446L29.6269 32.9712L29.8513 33.5113L32.7911 40.5882L33.2937 41.7982H31.9845H18.0156H16.7063L17.2089 40.5882L20.1488 33.5113L20.3731 32.9712L20.9554 32.9712ZM28.4623 34.7213H21.5377L19.3249 40.0482H30.6751L28.4623 34.7213Z",
    fill: "#EE4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5087 25.9671L16.6743 19.8015L17.293 19.1828L17.9116 19.8015L22.0885 23.9784L27.2929 18.7739L27.9116 18.1553L28.5302 18.7739L32.707 22.9508L38.2541 17.4038L39.4913 18.6412L33.3257 24.8068L32.707 25.4254L32.0884 24.8068L27.9116 20.6299L22.7071 25.8343L22.0885 26.453L21.4698 25.8343L17.293 21.6575L11.746 27.2045L10.5087 25.9671Z",
    fill: "#EE4540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.2491 16.4033H39.4991H40.3741V17.2783V22.5284H38.6241V18.1534H34.2491V16.4033Z",
    fill: "#EE4540"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudy3);
export default __webpack_public_path__ + "static/media/caseStudy3.0733d19f3081ec054d91593501deb5d4.svg";
export { ForwardRef as ReactComponent };